export default __webpack_public_path__ + "static/media/Clan Bound Gloves of the Plains.9befffd3.jpg";